/** @file Component-wise difference of two vectors. */
import type { Vec3 } from './vec3';

/** `a - b`. */
export function vec3Sub(a: Vec3, b: Vec3): Vec3 {
  return [a[0] - b[0], a[1] - b[1], a[2] - b[2]];
}
